<template>
  <div class="detail-with-icon">
    <div class="icon">
      <slot name="icon" />
    </div>
    <div class="detail-text">
      <slot name="detail-text" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.detail-with-icon {
  display: flex;
  align-items: flex-start;
}

.icon {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 30px;
}

.detail-text {
  flex: 1;
  max-width: calc(100% - 20px);
}
</style>
